import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from "lucide-react";
import { UserContext } from './UserContext';
import api from "../api/apiClient";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const CtaSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const { currentUser, isPrelaunch } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!acceptTerms) {
      toast.error('Du måste godkänna villkoren för att fortsätta', {
        position: 'top-center',
        autoClose: 3000,
      });
      return;
    }
    setIsSubmitting(true);
    try {
      await api.post('/api/prelaunch-signup', { email });
      setSubmitSuccess(true);
      setEmail('');
      toast.success('Tack för din förregistrering! Kolla din e-post.', {
        position: 'top-center',
        autoClose: 3000,
      });
    } catch (error) {
      const status = error.response?.status;
      if (status === 409) {
        toast.info('Denna e-postadress är redan registrerad', {
          position: 'top-center',
          autoClose: 3000,
        });
      } else {
        toast.error(error.response?.data?.error || 'Något gick fel', {
          position: 'top-center',
          autoClose: 3000,
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCreateClick = () => {
    if (!currentUser) {
      toast.info('Du måste vara inloggad för att skapa en bok', {
        position: 'top-center',
        autoClose: 3000,
      });
      return;
    }
    navigate('/skapa');
  };

  return (
    <section className="py-20 bg-warmWhite">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center animate-fade-up">
          <h2 className="text-3xl md:text-4xl font-bold font-quicksand text-magic-900 mb-6">
            {isPrelaunch
              ? "Redo för magin när vi lanserar?"
              : "Redo att skapa din egen saga?"}
          </h2>
          <p className="text-lg text-gray-600 font-open-sans mb-8">
            {isPrelaunch
              ? "Förregistrera dig nu och få exklusiv tillgång vid lanseringen!"
              : "Börja din magiska resa idag och skapa oförglömliga minnen med ditt barn"}
          </p>

          {isPrelaunch ? (
            <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-md border border-gray-200">
              {submitSuccess ? (
                <div className="text-center">
                  <h3 className="text-xl font-bold text-grey-600 mb-2">
                    Tack för din förregistrering!
                  </h3>
                  <p className="text-gray-600">
                    Du har fått en bekräftelse med rabattkoder till din e-post.
                  </p>
                </div>
              ) : (
                <>
                  <h3 className="text-xl font-bold text-center mb-4 text-gray-800">
                    Få 20% rabatt vid lansering!
                  </h3>
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Din e-postadress"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-turquoise"
                    />
                    <div className="flex items-start">
                      <input
                        type="checkbox"
                        id="terms-cta"
                        checked={acceptTerms}
                        onChange={(e) => setAcceptTerms(e.target.checked)}
                        className="mt-1 mr-2"
                      />
                      <label htmlFor="terms-cta" className="text-sm text-gray-600">
                        Jag godkänner villkoren och att min e-post används för att skicka rabattkod och information om lanseringen.
                      </label>
                    </div>
                    <button
                      type="submit"
                      disabled={isSubmitting || !acceptTerms}
                      className={`w-full bg-turquoise hover:bg-turquoise-dark text-white font-semibold py-3 px-6 rounded-full flex items-center justify-center transition-colors ${
                        (!acceptTerms || isSubmitting) ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                    >
                      <Sparkles className="w-5 h-5 mr-2" />
                      {isSubmitting ? 'Skickar...' : 'Få rabattkod'}
                    </button>
                  </form>
                </>
              )}
            </div>
          ) : (
            <button
              onClick={handleCreateClick}
              className="bg-turquoise hover:bg-turquoise-dark text-white font-semibold px-8 py-4 rounded-full transition-all hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center w-4/5 sm:w-2/5 mx-auto"
            >
              <Sparkles className="w-6 h-6 mr-2" />
              Skapa din första bok!
            </button>
          )}
        </div>
      </div>

      {/* Toast-container */}
      <ToastContainer />
    </section>
  );
};

export default CtaSection;
